module.exports = __webpack_public_path__ + "static/img/ma.2e4e2cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ma.jpg
// module id = vs7/
// module chunks = 78